import { render, staticRenderFns } from "./all-tables.vue?vue&type=template&id=07c0a9fc&scoped=true&"
import script from "./all-tables.vue?vue&type=script&lang=js&"
export * from "./all-tables.vue?vue&type=script&lang=js&"
import style0 from "./all-tables.vue?vue&type=style&index=0&id=07c0a9fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c0a9fc",
  null
  
)

export default component.exports